import statusInfoDictionary from '@widgets/statuses-info/i18n/ru/statuses-info.dic.json';

export const statusesInfo = {
  STATUSES_INFO: statusInfoDictionary,
};

export const statusesInfoNamespaces = ['STATUSES_INFO'];
